// extracted by mini-css-extract-plugin
module.exports = {"homeLink":"menu_homeLink__25k__","menuHeader":"menu_menuHeader__pjysY"};